export const toNum = data => {
    if (typeof data === "string") {
        if (data.match(/^[0-9]+$/)) {
            return parseInt(data)
        } else {
            return 1
        }
    }
    return data
}
